import React from 'react';
import { SERVICES } from '../data/mockData';
import { Target, BarChart3, Settings, Palette, Search, TrendingUp, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { api } from '../api';

const iconMap = {
  'target': Target,
  'bar-chart': BarChart3,
  'settings': Settings,
  'palette': Palette,
  'search': Search,
  'trending-up': TrendingUp,
};

const Services = () => {
  const [services, setServices] = React.useState(SERVICES);

  React.useEffect(() => {
    api.getServices().then(data => {
      if (data && data.length > 0) setServices(data);
    }).catch(() => {});
  }, []);
  return (
    <section id="services" className="bg-[#FDFEFA] py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 md:mb-14 gap-6">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-[#242326] text-3xl md:text-5xl lg:text-[56px] font-light leading-tight tracking-tight font-['Inter']"
          >
            What we do
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-[#4A4A48] text-lg font-['Lato'] font-light max-w-md"
          >
            As your growth marketing partner, we offer everything you need to drive results.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-30px' }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="group relative bg-white rounded-2xl p-8 md:p-10 border border-[#242326]/5 hover:border-[#83BF42]/30 hover:shadow-xl hover:shadow-[#83BF42]/5 transition-all duration-500 cursor-pointer"
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl bg-[#83BF42]/10 flex items-center justify-center mb-6 group-hover:bg-[#83BF42]/20 transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent className="w-6 h-6 text-[#83BF42]" />
                  )}
                </div>

                <h3 className="text-[#242326] text-xl md:text-2xl font-medium font-['Inter'] mb-3">
                  {service.title}
                </h3>

                <p className="text-[#4A4A48] text-[15px] leading-relaxed font-['Lato'] font-light mb-6">
                  {service.description}
                </p>

                <div className="flex items-center gap-1 text-[#83BF42] text-sm font-['Inter'] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Learn more
                  <ArrowRight className="w-3.5 h-3.5" />
                </div>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mt-14"
        >
          <button className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-[#242326]/20 text-[#242326] text-[15px] font-light hover:bg-[#242326] hover:text-white transition-all duration-300 font-['Inter'] group">
            Everything we do
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
